
<section v-if="promo" class="promo-result">
  <align small-gap flex>
    <div>
      <div v-if="promo.coupon.name" class="name">
        {{ promo.coupon.name }}
      </div>

      <div class="description">
        {{ promoDescription }}
      </div>
    </div>

    <icon-button icon="close" @click="$emit('clear')" />
  </align>
</section>
